module.exports = __webpack_public_path__ + "static/media/defecto.27c085af.png";